"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactStyleProptype = _interopRequireDefault(require("react-style-proptype"));
var _styles = require("./styles");
// eslint-disable-next-line react/display-name
const InputBase = _ref => {
  let {
    ariaDescription,
    className,
    errors,
    hideErrors,
    hideLabel,
    id,
    label,
    name,
    placeholder,
    required,
    style,
    value,
    children,
    'data-text': dataText,
    maxLength,
    ...props
  } = _ref;
  const containsErrors = errors.length > 0;
  const inputProps = {
    'aria-describedby': `${id}-errors` + (ariaDescription ? ` ${id}-description` : '') + (maxLength != null ? ` ${id}-character-count` : ''),
    'aria-invalid': containsErrors,
    'aria-required': required,
    containsErrors,
    id,
    name,
    placeholder,
    value,
    ...props
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className,
    style: style,
    "data-text": dataText
  }, /*#__PURE__*/_react.default.createElement(_styles.StyledLabel, {
    htmlFor: id,
    visible: !hideLabel
  }, label), children(inputProps), ariaDescription && /*#__PURE__*/_react.default.createElement(_styles.StyledDescription, {
    id: `${id}-description`
  }, ariaDescription), /*#__PURE__*/_react.default.createElement(_styles.ErrorMessagesContainer, {
    id: `${id}-errors`,
    visible: !hideErrors
  }, (0, _map.default)(errors).call(errors, error => /*#__PURE__*/_react.default.createElement(_styles.ErrorMessage, {
    key: error
  }, error))));
};
InputBase.propTypes = {
  /**
   * A description that will be read by screen readers. Meant to provide
   * instructions for more complex inputs.
   */
  ariaDescription: _propTypes.default.string,
  /**
   * A CSS class that will be applied to the outer div
   */
  className: _propTypes.default.string,
  /**
   * An array of error messages that will be rendered
   * below the input element as paragraph tags.
   */
  errors: _propTypes.default.arrayOf(_propTypes.default.string),
  /**
   * Whether or not the errors should be visible. Provides a means
   * to hide errors in the case where the errors will be rendered
   * in the consumer. They should still be rendered here, but hidden
   * visually for the sake of screen readers.
   */
  hideErrors: _propTypes.default.bool,
  /**
   * Whether or not the label should be visible. Provides a means
   * to hide the label in the case where a label will be rendered
   * in the consumer. It should still be rendered here, but hidden
   * visually for the sake of screen readers.
   */
  hideLabel: _propTypes.default.bool,
  /**
   * Sets the id of the input
   */
  id: _propTypes.default.string.isRequired,
  /**
   * A label displayed above the input
   */
  label: _propTypes.default.string.isRequired,
  /**
   * Sets the name of the input
   */
  name: _propTypes.default.string.isRequired,
  /**
   * Placeholder text for the input
   */
  placeholder: _propTypes.default.string,
  /**
   * Whether or not this is a required input. Only used to populate
   * the aria-required attribute of the input.
   */
  required: _propTypes.default.bool,
  /**
   * The style prop of the outer div
   */
  style: _reactStyleProptype.default,
  /**
   * The value of the input.
   * Useful if you want the input to be a controlled component.
   * You can add an onChange handler to update this.
   */
  value: _propTypes.default.string,
  children: _propTypes.default.func,
  'data-text': _propTypes.default.string,
  maxLength: _propTypes.default.number
};
InputBase.defaultProps = {
  ariaDescription: undefined,
  className: undefined,
  errors: [],
  hideErrors: false,
  hideLabel: false,
  placeholder: '',
  required: false,
  style: {},
  value: ''
};
var _default = exports.default = InputBase;
InputBase.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "InputBase",
  "props": {
    "ariaDescription": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "A description that will be read by screen readers. Meant to provide\ninstructions for more complex inputs.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "A CSS class that will be applied to the outer div",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "errors": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "An array of error messages that will be rendered\nbelow the input element as paragraph tags.",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "string"
        }
      },
      "required": false
    },
    "hideErrors": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Whether or not the errors should be visible. Provides a means\nto hide errors in the case where the errors will be rendered\nin the consumer. They should still be rendered here, but hidden\nvisually for the sake of screen readers.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "hideLabel": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Whether or not the label should be visible. Provides a means\nto hide the label in the case where a label will be rendered\nin the consumer. It should still be rendered here, but hidden\nvisually for the sake of screen readers.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "placeholder": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "Placeholder text for the input",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "required": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Whether or not this is a required input. Only used to populate\nthe aria-required attribute of the input.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "style": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "The style prop of the outer div",
      "type": {
        "name": "custom",
        "raw": "stylePropType"
      },
      "required": false
    },
    "value": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "The value of the input.\nUseful if you want the input to be a controlled component.\nYou can add an onChange handler to update this.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "id": {
      "description": "Sets the id of the input",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "label": {
      "description": "A label displayed above the input",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "name": {
      "description": "Sets the name of the input",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "children": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "data-text": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "maxLength": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    }
  }
};